import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef, useState } from 'react';
import { showApiErrorSnack } from '@/lib/show-api-error-snack';
import { cn } from '@/lib/utils';
import axiosClient from '../../actions/axios-client';

export function FileUpload({
  fileList,
  onFileUpload,
  onFileDelete,
  fullWidth = true,
  readOnly = false,
  variant = 'default',
}) {
  const inputRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const isHero = variant === 'hero';

  const uploadFile = (file) => {
    const headers = { 'Content-Type': file.type };
    axiosClient
      .post('/admin/image', file, { headers })
      .then((response) => {
        onFileUpload(response.data);
      })
      .catch((error) => {
        showApiErrorSnack(error, 'Image upload failed');
      });
  };

  const onInputChange = (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (file) {
      uploadFile(file);
    }
  };

  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (readOnly) {
      return;
    }
    const file = e.dataTransfer?.files?.[0];
    if (file?.type?.startsWith('image/')) {
      uploadFile(file);
    }
  };

  const first = fileList?.[0];
  const showThumb = Boolean(first?.url || first?.thumbUrl);

  return (
    <div
      className={cn(
        'clearfix festy-upload-root',
        isHero && 'festy-upload-root--hero',
      )}
      style={{ width: fullWidth || isHero ? '100%' : 'auto' }}
    >
      {!readOnly && (
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={onInputChange}
        />
      )}
      {showThumb ? (
        <div
          className={cn(
            'festy-upload-tile relative align-top',
            isHero ? 'block w-full' : 'inline-block',
          )}
        >
          <button
            type="button"
            className={cn(
              'border-none bg-transparent p-0',
              isHero && 'block w-full',
            )}
            onClick={() => setPreviewUrl(first.url || first.thumbUrl)}
          >
            <img
              src={first.url || first.thumbUrl}
              alt=""
              className={
                isHero
                  ? 'festy-upload-hero-img'
                  : 'h-auto max-h-[150px] w-full max-w-[150px] object-contain'
              }
            />
          </button>
          {!readOnly && (
            <button
              type="button"
              className="absolute right-2 top-2 rounded bg-black/55 px-2 py-1 text-xs text-white"
              onClick={() => onFileDelete?.()}
            >
              Remove
            </button>
          )}
        </div>
      ) : (
        !readOnly && (
          <button
            type="button"
            className={cn(
              'festy-upload-trigger festy-upload-tile inline-flex cursor-pointer flex-col items-center justify-center gap-1 border-none bg-[#fafafa] align-top text-[var(--primary)]',
              isHero && 'festy-upload-trigger--hero',
            )}
            onClick={() => inputRef.current?.click()}
            onDragOver={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onDrop={onDrop}
          >
            <FontAwesomeIcon
              icon={['fas', isHero ? 'cloud-arrow-up' : 'camera']}
              className={isHero ? 'text-3xl' : 'text-2xl'}
            />
            <span className={isHero ? 'text-base' : 'text-sm'}>
              {isHero
                ? 'Click to upload or drag and drop event image'
                : 'Upload'}
            </span>
          </button>
        )
      )}
      {previewUrl ? (
        <button
          type="button"
          className="bethere-modal-overlay fixed inset-0 flex cursor-default items-center justify-center border-none bg-black/70 p-4"
          onClick={() => setPreviewUrl(null)}
        >
          <img
            src={previewUrl}
            alt=""
            className="max-h-[90vh] max-w-full cursor-default object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </button>
      ) : null}
    </div>
  );
}
